import { Guid, Nillable } from '@web/utils';
import { WarehouseProductQuantityHistoryReceiptResponse } from './warehouse-product-quantity-history-receipt.response';
import { WarehouseProductQuantityHistoryRestockResponse } from './warehouse-product-quantity-history-restock.response';
import { WarehouseProductQuantityHistoryReleaseResponse } from './warehouse-product-quantity-history-release.response';
import { jsonMember, jsonObject } from 'typedjson';
import { WarehouseProductQuantityHistoryReasonType } from '../../enums/warehouse-product-quantity-history-reason-type';

@jsonObject
export class WarehouseProductQuantityHistoryCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Number)
  public readonly change!: number;

  @jsonMember(Number)
  public readonly quantityBeforeChange!: number;

  @jsonMember(Number)
  public readonly quantityAfterChange!: number;

  @jsonMember(String)
  public readonly reason!: WarehouseProductQuantityHistoryReasonType;

  @jsonMember(WarehouseProductQuantityHistoryReceiptResponse)
  public readonly receipt?: Nillable<WarehouseProductQuantityHistoryReceiptResponse>;

  @jsonMember(WarehouseProductQuantityHistoryReleaseResponse)
  public readonly release?: Nillable<WarehouseProductQuantityHistoryReleaseResponse>;

  @jsonMember(WarehouseProductQuantityHistoryRestockResponse)
  public readonly restock?: Nillable<WarehouseProductQuantityHistoryRestockResponse>;

  @jsonMember(String)
  public readonly createdBy?: Nillable<String>;
}
